import { useDatabaseContent } from '@databases/database-state';
import { getService } from '@databases/service-container';
import { useEffect } from 'react';

export interface PopoverSoftSelectionProps {
  entryId: string | undefined;
  fieldId: string;
  isRenderedInSidePanel: boolean | undefined;
  clearExistingSelection?: boolean;
}

export const usePopoverSoftSelection = ({
  entryId,
  fieldId,
  isRenderedInSidePanel,
  clearExistingSelection = false,
}: PopoverSoftSelectionProps) => {
  const selectionsActions = getService('SelectionsActions');
  const { contentId } = useDatabaseContent();

  useEffect(() => {
    // No need to set softSelection if popover is rendered in side panel
    if (!isRenderedInSidePanel && entryId && contentId) {
      selectionsActions.selectValues([{ entryId, fieldId }], {
        clear: clearExistingSelection,
      });
    }
  }, [
    selectionsActions,
    entryId,
    fieldId,
    clearExistingSelection,
    isRenderedInSidePanel,
    contentId,
  ]);
};
